import { formatDate } from '../../utils';

const transformPatients = ({ results = [], count, ...singlePatient } = {}) => {
  if (singlePatient?.personId) {
    results.push(singlePatient);
  }
  return {
    count,
    results: results.map((patient) => {
      const findTelecomRecord = (system) => patient?.telecom?.find((tel) => tel.system === system);
      const emailRecord = findTelecomRecord('email');
      const phoneRecord = findTelecomRecord('phone');
      const phone = phoneRecord?.value.replace(/(\d{3})(\d{3})(\d{4})/, '($1)-$2-$3');
      const {
        active,
        address,
        birthDate,
        carePathwayType,
        createdAt,
        externalMedicalRecordNumber = null,
        gender,
        id,
        name,
        pathWay,
        personId,
        podId,
        podName,
        raceEthnicity,
        sexForClinicalUse,
        typeOfInsurance,
        insurances = [],
        withingsUserId,
        preferredTimeZone,
        enrollmentStatus,
        orderRequestId = null,
        deactivatedDateTime = null,
      } = patient;

      return {
        address: address[0]?.line?.[0],
        addressId: address[0]?.id,
        birthDate: formatDate(birthDate, 'MM/DD/YYYY'),
        carePathwayType,
        city: address[0]?.city,
        email: emailRecord?.value,
        emailId: emailRecord?.id,
        enrolledOn: formatDate(createdAt, 'YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
        externalMedicalRecordNumber,
        firstName: name[0]?.given[0],
        gender,
        lastName: name[0]?.family,
        nameId: name[0]?.id,
        pathway: pathWay,
        patientId: id,
        personId,
        podId,
        podName,
        phoneId: phoneRecord?.id,
        phone,
        raceEthnicity,
        sexForClinicalUse,
        state: address[0]?.state,
        status: active ? 'Active' : 'Inactive',
        typeOfInsurance,
        insurances,
        zip: address[0]?.postalCode,
        withingsUserId,
        preferredTimeZone,
        enrollmentStatus,
        orderRequestId,
        deactivatedDateTime,
      };
    }),
  };
};

export default transformPatients;
